import React from "react";

const Progress = ( {progressStatus, isSelectAddress = false, addressEnumChange, isChildren = false } ) => {

    console.log(progressStatus)
 

  return (
    <div className="registration-progress my-40">
        <div className="container">
            <div className={progressStatus+" step-progress  position-relative row row-cols-3 row-cols-md-3"}>
                
                <div className="step text-center z-2 ">
                    <div className=" ">
                        <i class="ph ph-circle text-32 bg-white unchecked"></i>
                        <i class="ph-fill ph-check-circle text-32  bg-white checked"></i>
                    </div>
                    <div className="text_quicksand fw-bold text-16 ">
                        Document Verification
                    </div>
                </div>
                <div className="step text-center z-2 ">
                    <div className=" ">
                        <i class="ph ph-circle text-32 bg-white unchecked"></i>
                        <i class="ph-fill ph-check-circle text-32  bg-white checked"></i>
                    </div>
                    <div className="text_quicksand fw-bold text-16 ">
                        Shop Information
                    </div>
                </div>
                <div className="step text-center z-2 ">
                    <div  className=" ">
                       <i class="ph ph-circle text-32 bg-white unchecked"></i>
                        <i class="ph-fill ph-check-circle text-32 bg-white checked"></i>
                    </div>
                    <div className="text_quicksand fw-bold text-16 ">
                        Summary Payment
                    </div>
                </div>
                <div className="position-absolute progress-bar" style={{border:"none", backgroundColor:"#E6E6E6", padding:"0", height: "2px", top:"15px" ,width: "65%",left: "50%",transform: "translateX(-50%)"}}>
                    <div className="progress-bar-fill"></div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default Progress;